import { useMutation } from "@tanstack/react-query";
import { useOrderContext } from "app/providers/OrderProvider";
import { toast } from "react-toastify";
import { api } from "shared/api";
import { setStateVoucher } from "shared/store/voucher/voucherStore";

export const apiValidateVoucher = async ({
  voucher,
  model,
}: {
  voucher: string;
  model: string;
}) => {
  const res = await api().gersValidateDiscountCode(voucher, model);
  return res.data;
};

export const useVoucherOrdersAddition = () => {
  const {
    mutateAsync,
    status,
    isLoading,
    reset: resetAddVoucherToCart,
  } = useMutation(apiValidateVoucher);

  const { order } = useOrderContext();

  const addVoucherToOrders = async (
    voucher: string,
    model: string,
  ): Promise<boolean> => {
    try {
      const voucherData = await mutateAsync({ voucher, model });

      if (
        voucherData.warrantyPackages &&
        voucherData.warrantyPackages.length > 0 &&
        order?.warrantyPackage
      ) {
        toast.error("Voucher is ongeldig!");
        return false;
      }
      if (
        voucherData &&
        ((voucherData.applyToOrder && model === "order") ||
          (voucherData.applyToStandardOrder && model === "standardOrder"))
      ) {
        // Set the voucher
        setStateVoucher(voucherData);
        toast.success("Voucher is toegevoegd!");
        return true;
      } else {
        toast.error("Voucher is ongeldig!");
        return false;
      }
    } catch (error: any) {
      toast.error("Voucher is ongeldig!");
      return false;
    }
  };

  return { addVoucherToOrders, isLoading, resetAddVoucherToCart, status };
};
